import { defineStore } from 'pinia';

export const useScheduleServiceStore = defineStore('ScheduleServiceStore', {
  state() {
    return {
      enableScheduleServiceButton: false,
    };
  },
  actions: {},
});
